// Idempotency-Key estable por intención del usuario: el reintento manual reusa la misma llave.

export class IntentKeys {
    private readonly keys = new Map<string, string>();

    /** La llave de la intención; la crea la primera vez. */
    keyFor(intent: string): string {
        const existing = this.keys.get(intent);
        if (existing !== undefined) return existing;
        const key = crypto.randomUUID();
        this.keys.set(intent, key);
        return key;
    }

    /** La intención ya se cumplió: la siguiente vez lleva llave nueva. */
    settle(intent: string): void {
        this.keys.delete(intent);
    }
}
